<template>
  <div>
    <v-card color="grey lighten-1 white--text">
      <v-layout align-center row>
        <v-flex xs1 md1 pl-4>
          Icon
        </v-flex>
        <v-flex xs2 md2 pl-3>
          Name
        </v-flex>
        <v-flex xs3 md3>
          Description
        </v-flex>
        <v-flex xs3 md3 pl-3>
          Active Tariff
        </v-flex>
        <v-flex xs2 md2>
          Cost Estimate
        </v-flex>
        <v-flex xs1 md1 pr-4>
          <v-layout justify-end>
            Edit
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <draggable v-model="rideTypesStore" @change="orderChanged">
      <v-card
        v-for="rideType in rideTypesStore" 
        :key="rideType.id"
        :color="rideType.enabled ? 'white' : 'grey lighten-2'"
      >
        <v-layout align-center row>
          <v-flex xs1 md1 pl-2 pt-1 pb-1>
            <v-avatar
              color="grey lighten-4"
              :size="64"
            >
              <img :src="rideType.image">
            </v-avatar>
          </v-flex>
          <v-flex xs2 md2>
            <v-card-title><h3>{{rideType.name}}</h3></v-card-title>
          </v-flex>
          <v-flex xs3 md3>
            {{ rideType.description }}
          </v-flex>
          <v-flex xs3 md3>
            <v-card-title>{{getTariffName(rideType.tariff)}}</v-card-title>
          </v-flex>
          <v-flex xs2 md2>
            <v-progress-circular
              v-if="loadingCostEstimates && rideType.enabled"
              indeterminate
              color="primary"
            ></v-progress-circular>
            {{ rideType.enabled ? '' : 'N/A' }}
            {{ (rideType.enabled && !loadingCostEstimates) ? rideType.estimatedCost : '' }}
          </v-flex>
          <v-flex xs1 md1 pr-2>
            <v-layout justify-end>
              <v-card-actions>
                <v-btn icon ripple @click="edit(rideType.id)">
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-card-actions>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "ride_type_list",
  components: {
    draggable
  },
  props: {
    ride_types: Array,
    loading: Boolean,
    loadingCostEstimates: Boolean
  },
  data: function() {
    return {
      rideTypesStore: []
    }
  },
  beforeMount: async function() {
    this.rideTypesStore = this.ride_types;
  },
  methods: {
    edit: function(id) {
      this.$emit("edit", id);
    },
    orderChanged: function() {
      this.$emit('orderChange', this.rideTypesStore);
    },
    getTariffName: function(tariff) {
      if(tariff.name) {
        return tariff.name + " Modifier";
      } else {
        return "Base Tariff"
      }
    }
  },
  watch: {
    ride_types: function() {
      this.rideTypesStore = this.ride_types;
    },
    rideTypesStore: function() {

    }
  }
}
</script>
